<script setup lang="ts">
import { useId } from 'vue';

import type { Temporal } from '@shared/lib/date-time';

import { formatDate } from '@shared/lib/date-time';

import { BaseDropdown } from '../dropdown';
import { IconCalendar } from '../icons';
import DatePicker from './DatePicker.vue';

/** Поле даты формы: кнопка с датой и календарь `DatePicker` во всплывающем окне. */
defineProps<{
  label: string;
  today: Temporal.PlainDate | null;
  min?: Temporal.PlainDate;
  max?: Temporal.PlainDate;
  invalid?: boolean;
  disabled?: boolean;
}>();
const model = defineModel<Temporal.PlainDate | null>({ required: true });
const id = useId();
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label
      :for="id"
      class="text-sm font-medium text-(--base-popup-text-color)"
      >{{ label }}</label
    >
    <BaseDropdown
      :disabled="disabled"
      :content="{ align: 'start', side: 'bottom' }"
    >
      <template #trigger="{ toggle }">
        <button
          :id="id"
          type="button"
          class="flex min-h-11 w-44 items-center gap-2 rounded-lg border px-3 text-left text-sm tabular-nums disabled:opacity-60"
          :class="invalid ? 'border-(--base-error-color)' : 'border-(--base-popup-border-color)'"
          :disabled="disabled"
          @click="toggle"
        >
          <IconCalendar
            class="text-(--base-popup-secondary-color)"
            :width="18"
            :height="18"
          />
          {{ model ? formatDate(model) : 'Выберите дату' }}
        </button>
      </template>
      <template #content="{ close }">
        <DatePicker
          v-if="today"
          v-model="model"
          :today="today"
          :min="min"
          :max="max"
          @close="close"
        />
      </template>
    </BaseDropdown>
  </div>
</template>
